<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2c"><a id="pvii"></a><span epub:type="pagebreak" id="pagevii" title="vii">Illustrations</span></h2>
<p class="paraa"><span href="#/xhtml/plates#fig1" title="Link target outside of Sample">Angus and Neilian with Seryozha and Volodya in their Moscow apartment</span></p>
<p class="paraa"><span href="#/xhtml/plates#fig2" title="Link target outside of Sample">Volodya aged four with his mother and aunt and the President of the Soviet Union, Mikhail Kalinin</span></p>
<p class="paraa"><span href="#/xhtml/plates#fig3" title="Link target outside of Sample">Garik and Inna Basyrov</span></p>
<p class="paraa"><span href="#/xhtml/plates#fig4" title="Link target outside of Sample">‘Couple’ by Garik Basyrov</span></p>
<p class="paraa"><span href="#/xhtml/plates#fig5" title="Link target outside of Sample">A crowd gathers to watch me performing on a ladder . . .</span></p>
<p class="paraa"><span href="#/xhtml/plates#fig6" title="Link target outside of Sample">. . . and how the piece to camera appeared in the report</span></p>
<p class="paraa"><span href="#/xhtml/plates#fig7" title="Link target outside of Sample">Filing a report by satellite telephone from Chechnya</span></p>
<p class="paraa"><span href="#/xhtml/plates#fig8" title="Link target outside of Sample">Russian troops pose in front of the destroyed presidential palace in Grozny</span></p>
<p class="paraa"><span href="#/xhtml/plates#fig9" title="Link target outside of Sample">My friend Nikolai Vorontsov with Boris Yeltsin in front of the Russian parliament during the 1991 coup</span></p>
<p class="paraa"><span href="#/xhtml/plates#fig10" title="Link target outside of Sample">My children, Ewan, Duncan and Katie, on the BBC car near Red Square</span></p>
<p class="paraa"><span href="#/xhtml/plates#fig10a" title="Link target outside of Sample">Ewan playing under Lenin’s watchful eye in 1989</span></p>
<p class="paraa"><span href="#/xhtml/plates#fig11" title="Link target outside of Sample">Soviet soldiers raise the Red Flag above the Reichstag in Berlin at the end of the Second World War</span></p>
<p class="paraa"><span href="#/xhtml/plates#fig12" title="Link target outside of Sample">Yevgeny Khaldei, the photographer of the Reichstag picture, reunited with the then 18-year-old soldier who raised the flag, Aleksey Kovalyov</span></p>
<p class="paraa"><span href="#/xhtml/plates#fig13" title="Link target outside of Sample">Consulting the shaman in Siberia</span></p>
<p class="paraa"><span href="#/xhtml/plates#fig15" title="Link target outside of Sample">On a plane with the man who might have been president, Boris Nemtsov</span></p>
<p class="paraa"><span href="#/xhtml/plates#fig16" title="Link target outside of Sample">. . . and meeting the man who did become president, Vladimir Putin, at a Valdai Club dinner</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// illu.vue?7ffd0cd2